import { Routes } from '@angular/router';
import { AuthGuard } from './gaurd/auth.guard';
import { UserGuard } from './gaurd/user.guard';
import { userResolver } from './resolver/user.resolver';
import { companyUserResolver } from './resolver/company_user.resolver';
import { CompanyUserGuard } from './gaurd/company_user.guard';
import { stripeAccountResolver } from './resolver/stripe-account.resolver';
import { chooseCompanyGuard } from './gaurd/choose_company.guard';

export const routes: Routes = [
    {
        path:'auth',
        loadComponent: () => import('./auth/auth.component').then((m)=>m.AuthComponent),
        canActivate:[AuthGuard],
        children:[
            {
                path:'signup',
                loadComponent: () => import('./auth/signup/signup.component').then((m)=>m.SignupComponent)
            },
            {
                path:'login',
                loadComponent: () => import('./auth/login/login.component').then((m)=>m.LoginComponent)
            },
            {
                path:'**',
                redirectTo:'login'
            }
        ]
    },
    {
        path:'reset_password',
        loadComponent: () => import('./home/account/reset-password/reset-password.component').then((m)=>m.ResetPasswordComponent),
        canActivate:[AuthGuard],
    },
    {
        path:'onboard',
        loadComponent: () => import('./onboard/onboard.component').then((m)=>m.OnboardComponent),
        canActivate:[AuthGuard,CompanyUserGuard],
    },
    {
        path:'choose_company',
        loadComponent:() => import('./home/choose-company/choose-company.component').then((m)=>m.ChooseCompanyComponent),
        canActivate:[AuthGuard,CompanyUserGuard],
    },
    {
        path:'dashboard',
        loadComponent: () => import('./home/home.component').then((m)=>m.HomeComponent),
        canActivate:[AuthGuard,chooseCompanyGuard],
        resolve:[userResolver,companyUserResolver],
        children:[
            {
                path:'home',
                loadComponent: () => import('./home/landing/landing.component').then((m)=>m.LandingComponent)
            },
            {
                path:'trips',
                loadComponent: () => import('./home/trips/trips.component').then((m)=>m.TripsComponent)
            },
            {
                path:'bike',
                children:[
                    {
                        path:'rent_bike',
                        loadComponent: () => import('./home/bike/rent-bike/rent-bike.component').then((m)=>m.RentBikeComponent)
                    },
                    {
                        path:'devices',
                        loadComponent: () => import('./home/bike/devices/devices.component').then((m)=>m.DevicesComponent)
                    },
                    {
                        path:'own_bike',
                        loadComponent: () => import('./home/bike/own-bike/own-bike.component').then((m)=>m.OwnBikeComponent)
                    },
                ]
            },
            {
                path:'map_view',
                loadComponent: () => import('./home/bike/map-view/map-view.component').then((m)=>m.MapViewComponent)
            },
            {
                path:'stop',
                loadComponent: () => import('./home/stop/stop.component').then((m)=>m.StopComponent)
            },
            {
                path:'price',
                children:[
                    {
                        path:'prices',
                        loadComponent: () => import('./home/price/prices/prices.component').then((m)=>m.PricesComponent)
                    },
                    {
                        path:'plans',
                        loadComponent: () => import('./home/price/plans/plans.component').then((m)=>m.PlansComponent)
                    },
                    {
                        path:'commission_rule',
                        loadComponent: () => import('./home/price/commission-rule/commission-rule.component').then((m)=>m.CommissionRuleComponent)
                    },
                ]
            },
            {
                path:'whitelist',
                children:[
                    {
                        path:'whitelist-user',
                        loadComponent: () => import('./home/whitelist/whitelist-users/whitelist-users.component').then((m)=>m.WhitelistUsersComponent)
                    },
                    {
                        path:'whitelist-groups',
                        loadComponent: () => import('./home/whitelist/whitelist-groups/whitelist-groups.component').then((m)=>m.WhitelistGroupsComponent)
                    },
                ]
            },
            {
                path:'client',
                children:[
                    {
                        path:'commission/:commission_id',
                        loadComponent: () => import('./home/client/client-commission/client-commission.component').then((m)=>m.ClientCommissionComponent)
                    },
                    {
                        path:'clients',
                        loadComponent: () => import('./home/client/clients/clients.component').then((m)=>m.ClientsComponent)
                    },
                    {
                        path:'',
                        pathMatch:'full',
                        redirectTo:'clients'
                    },
                    {
                        path:'**',
                        redirectTo:'clients'
                    },
                ]
            },
            {
                path:'voucher',
                loadComponent: () => import('./home/voucher/voucher.component').then((m)=>m.VoucherComponent)
            },
            {
                path:'logs',
                loadComponent: () => import('./home/logs/logs.component').then((m)=>m.LogsComponent)
            },
            {
                path:'payments',
                resolve:[stripeAccountResolver],
                children:[
                    {
                        path:'balance_transfer',
                        loadComponent: () => import('./home/payments/balance-transfer/balance-transfer.component').then((m)=>m.BalanceTransferComponent)
                    },
                    {
                        path:'payouts',
                        loadComponent: () => import('./home/payments/payouts/payouts.component').then((m)=>m.PayoutsComponent)
                    },
                ]
            },
            {
                path:'account',
                children:[
                    {
                        path:'account_overview',
                        loadComponent:()=> import('./home/account/account-overview/account-overview.component').then((m)=>m.AccountOverviewComponent)
                    },
                    {
                        path:'account_management',
                        loadComponent:()=> import('./home/account/account-management/account-management.component').then((m)=>m.AccountManagementComponent)
                    },
                    {
                        path:'account_setting',
                        loadComponent:()=> import('./home/account/account-setting/account-setting.component').then((m)=>m.AccountSettingComponent)
                    },
                ]
            },
            {
                path:'stripe-onboard-success',
                loadComponent:()=> import('./home/stripe-onboard-return/stripe-onboard-return.component').then((m)=>m.StripeOnboardReturnComponent)
            },
            {
                path:'',
                pathMatch:'full',
                redirectTo:'home'
            },
            {
                path:'**',
                redirectTo:'home'
            },
        ]
    },
    {
        path:'',
        pathMatch:'full',
        redirectTo:'dashboard'
    },
    {
        path:'**',
        redirectTo:''
    }
];
